import { z } from "zod";

export const catalogFlagsSchema = z
  .object({
    publish: z.boolean().optional(),
    sale: z.boolean().optional(),
    sold: z.boolean().optional()
  })
  .strict();

export function resolveCatalogFlags(
  previous: { publicationState: string; commerceState: string },
  flags: z.infer<typeof catalogFlagsSchema>
) {
  const wasPublished = previous.publicationState === "published";
  const wasForSale = previous.commerceState === "available";
  const wasSold = previous.commerceState === "sold";
  const sale = flags.sale ?? wasForSale;
  const sold = flags.sold ?? wasSold;
  if (sale && sold) throw new Error("An artwork cannot be both for sale and sold.");
  return {
    publicationState:
      flags.publish === undefined || flags.publish === wasPublished
        ? previous.publicationState
        : flags.publish
          ? "published"
          : "unpublished",
    commerceState:
      sale === wasForSale && sold === wasSold
        ? previous.commerceState
        : sold
          ? "sold"
          : sale
            ? "available"
            : "not_offered"
  };
}
